export default "__VITE_ASSET__C6hDC5eL__"